import { defineMessages, useIntl } from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const messages = defineMessages({
  modified: {
    id: 'modified',
    defaultMessage: 'Ultimo aggiornamento',
  },
});

interface PageMetadataProps {
  content: { modified: Date; show_modified: boolean };
}

/**
 * PageMetadata view component class.
 * @function Metadata
 * @params {object} content: Content object.
 * @returns {string} Markup of the component.
 */
const PageMetadata: React.FC<PageMetadataProps> = ({ content }) => {
  const intl = useIntl();
  moment.locale(intl.locale);

  return content.show_modified ? (
    <article id="metadata" className="bottom-metadata">
      <span>{intl.formatMessage(messages.modified)}:</span>{' '}
      {moment(content.modified).format('DD-MM-Y HH:MM')}
    </article>
  ) : (
    <></>
  );
};
export default PageMetadata;
